import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import GoogleReviews from './GoogleReviews';
import ADACPartner from './ADACPartner';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Schlüsseldienst.services</h3>
            <p className="text-sm mb-4">
              Schnelle und zuverlässige Türöffnung in ganz Dortmund. Transparente Festpreise ohne versteckte Kosten.
            </p>
            
            {/* Google Reviews Badge */}
            <div className="mb-4 pb-4 border-b border-gray-700">
              <GoogleReviews variant="compact" />
            </div>
            
            <div className="space-y-2 text-sm">
              <div className="flex items-start gap-2">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>Neben dem Brand 10<br />44135 Dortmund</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={16} />
                <a href="tel:+4923139085116" className="hover:text-orange-400">0231 39085116</a>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={16} />
                <a href="mailto:info@schluesseldienst.services" className="hover:text-orange-400">
                  info@schluesseldienst.services
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Clock size={16} />
                <span>24/7 Notdienst</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Wichtige Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/schluesseldienst-dortmund" className="hover:text-orange-400">Startseite</Link></li>
              <li><Link to="/preise" className="hover:text-orange-400">Preise</Link></li>
              <li><Link to="/einsatzgebiete" className="hover:text-orange-400">Einsatzgebiete</Link></li>
              <li><Link to="/ratgeber" className="hover:text-orange-400">Ratgeber</Link></li>
              <li><Link to="/sitemap.html" className="hover:text-orange-400">Sitemap</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Leistungen</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/leistungen/tueroeffnung-zugefallen" className="hover:text-orange-400">Türöffnung zugefallen</Link></li>
              <li><Link to="/leistungen/tueroeffnung-verschlossen" className="hover:text-orange-400">Türöffnung verschlossen</Link></li>
              <li><Link to="/leistungen/autooeffnung" className="hover:text-orange-400">Autoöffnung</Link></li>
              <li><Link to="/leistungen/tresoroeffnung" className="hover:text-orange-400">Tresoröffnung</Link></li>
              <li><Link to="/leistungen/schlosswechsel" className="hover:text-orange-400">Schlosswechsel</Link></li>
              <li><Link to="/leistungen/einbruchschutz" className="hover:text-orange-400">Einbruchschutz</Link></li>
              <li><Link to="/leistungen/einbruchschaden-reparatur" className="hover:text-orange-400">Einbruchschaden Reparatur</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Rechtliches</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/impressum" className="hover:text-orange-400">Impressum</Link></li>
              <li><Link to="/datenschutz" className="hover:text-orange-400">Datenschutz</Link></li>
            </ul>
            <div className="mt-6 text-xs">
              <p>Schössow Dienstleistungen UG (haftungsbeschränkt)</p>
              <p>HRB 29517 Amtsgericht Dortmund</p>
              <p>USt-ID: DE310018782</p>
            </div>
            
            {/* ADAC Partner Badge */}
            <div className="mt-6">
              <ADACPartner variant="badge" />
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-center">
          <p>&copy; {currentYear} Schlüsseldienst.services - Alle Rechte vorbehalten</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
